import Resource from '@assets/utils/resource';
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* CONST Includes */
const VIEWITEMLIST = 'view_item_list';
const VIEWITEM = 'view_item';
const VIEWCART = 'view_cart';
const SIGNUP = 'sign_up';
const SELECTITEM = 'select_item';
const REMOVEFROMCART = 'remove_from_cart';
const PURCHASE = 'purchase';
const LOGIN = 'login';
const BEGINCHECKOUT = 'begin_checkout';
const ADDTOCART = 'add_to_cart';
const ADDTOWISHLIST = 'add_to_wishlist';
const ADDSHIPPINGINFO = 'add_shipping_info';
const ADDPAYMENTINFO = 'add_payment_info';
const SEARCH = 'search';

const enabled = Resource.getSitePreference('google', 'googleTagManagerEnabled');

/* Object of list type */
const listObj = {
    '': '',
    home_page: 'Home Page',
    search_results: 'Search Results',
    view_cart: 'View Cart',
    product_category: 'Product Category',
    related_products: 'Related Products',
};

/**
 * Measure adding a product to a shopping cart by using an 'add' actionFieldObject
 * and a list of productFieldObjects.
 * @param {Array} item product added to cart.
 * @param {number} value total cart value.
 */
export function onAddToCart(item, value) {
    if (!item || !enabled) {
        return;
    }
    window.dataLayer.push({
        event: ADDTOCART,
        ecommerce: {
            currency: window.currency || '',
            value,
            items: item,
        },
    });
}

/**
 * Measure adding a product to a shopping cart by using an 'add' actionFieldObject
 * and a list of productFieldObjects.
 * @param {Array} item product added to cart.
 * @param {number} value total cart value.
 */
export function onAddToWishlist(item) {
    if (!item || !enabled) {
        return;
    }
    window.dataLayer.push({
        event: ADDTOWISHLIST,
        ecommerce: {
            currency: window.currency || '',
            items: item,
        },
    });
}

/**
 * Measure product impression on page detail load.
 *
 * @param {Array} item product added to cart.
 * @param {number} value total cart value.
 */
export function onViewItem(item, value, listID = '') {
    if (!item || !item.length || !enabled) {
        return;
    }

    if (!item[0].item_list_id) {
        item[0].item_list_id = listID;
    }

    item[0].item_list_name = listObj[item[0].item_list_id];

    window.dataLayer.push({
        event: VIEWITEM,
        ecommerce: {
            currency: window.currency || '',
            value,
            items: item,
        },
    });
}

/**
 * Measure the removal of a product from a shopping cart.
 * @param {Array} item product to removed from cart
 * @param {number} value total cart value.
 */
export function onRemoveFromCart(item, value) {
    if (!item || !enabled) {
        return;
    }
    window.dataLayer.push({
        event: REMOVEFROMCART,
        ecommerce: {
            currency: window.currency || '',
            value,
            items: item,
        },
    });
}

/**
 * Measures product impressions and also tracks a standard
 * pageview for the tag configuration.
 * Product impressions are sent by pushing an impressions object
 * containing one or more impressionFieldObjects.
 * @param {string} listID The list ID.
 * @param {Object} items An object representing a product.
 */
export function onViewItemList(listID, items) {
    if (!items.length || !enabled) {
        return;
    }

    items.forEach((item) => {
        item.item_list_id = listID;
        item.item_list_name = listObj[listID];
    });

    window.dataLayer.push({
        event: VIEWITEMLIST,
        ecommerce: {
            currency: window.currency || '',
            item_list_id: listID,
            item_list_name: listObj[listID],
            items,
        },
    });
}

/**
 * Measures product impressions in a shopping cart.
 * Product impressions are sent by pushing an impressions object
 * containing one or more impressionFieldObjects.
 * @param {Object} items An object representing a product.
 * @param {number} value total cart value.
 */
export function onViewCart(items, value) {
    if (!items.length || !enabled) {
        return;
    }

    window.dataLayer.push({
        event: VIEWCART,
        ecommerce: {
            currency: window.currency || '',
            value,
            items,
        },
    });
}

/**
 * Measures product selection in a list.
 * Product selection are sent by pushing a selection object
 * containing one or more selectionFieldObjects.
 * @param {string} listID The list ID.
 * @param {Object} items An object representing a product.
 */
export function onItemSelect(item, listID = '') {
    if (!item.length || !enabled) {
        return;
    }

    if (!item[0].item_list_id) {
        item[0].item_list_id = listID;
    }
    item[0].item_list_name = listObj[item[0].item_list_id];

    window.dataLayer.push({
        event: SELECTITEM,
        ecommerce: {
            currency: window.currency || '',
            item_list_id: item[0].item_list_id,
            item_list_name: item[0].item_list_name,
            items: item,
        },
    });
}

/**
 * Measures product impressions in a shopping cart.
 * Product impressions are sent by pushing an impressions object
 * containing one or more impressionFieldObjects.
 * @param {Object} items An object representing a product.
 * @param {number} value total cart value.
 * @param {string} coupon coupon code.
 */
export function onCheckoutBegin(items, value, coupon = '') {
    if (!items.length || !enabled) {
        return;
    }

    window.dataLayer.push({
        event: BEGINCHECKOUT,
        ecommerce: {
            currency: window.currency || '',
            value,
            coupon,
            items,
        },
    });
}

/**
 * Measures impressions in shipping submit checkout.
 *
 * @param {Object} items An object representing a product.
 * @param {number} value total cart value.
 * @param {string} shippingTier coupon code.
 * @param {string} coupon payment method.
 */
export function onAddShippingInfo(items, value, shippingTier, coupon = '') {
    if (!items.length || !enabled) {
        return;
    }

    window.dataLayer.push({
        event: ADDSHIPPINGINFO,
        ecommerce: {
            currency: window.currency || '',
            value,
            coupon,
            shipping_tier: shippingTier,
            items,
        },
    });
}

/**
 * Measures impressions in payment submit checkout.
 *
 * @param {Object} items An object representing a product.
 * @param {number} value total cart value.
 * @param {string} shippingTier coupon code.
 * @param {string} coupon payment method.
 */
export function onAddPaymentInfo(items, value, paymentType, coupon = '') {
    if (!items.length || !enabled) {
        return;
    }

    window.dataLayer.push({
        event: ADDPAYMENTINFO,
        ecommerce: {
            currency: window.currency || '',
            value,
            coupon,
            payment_type: paymentType,
            items,
        },
    });
}

/**
 * Measures impressions in purchase submit checkout.
 *
 * @param {Object} items An object representing a product.
 * @param {string} transactionID transaction ID.
 * @param {number} value total cart value.
 * @param {number} tax total tax value.
 * @param {number} shipping total shipping costs.
 * @param {string} paymentType payment method.
 * @param {string} shippingTier coupon code.
 * @param {string} coupon payment method.
 */
export function onPurchase(
    items,
    transactionID,
    value,
    tax,
    shipping,
    paymentType,
    shippingTier,
    customerObj,
    coupon = '',
) {
    if (!items.length || !enabled) {
        return;
    }
    const {
        new_client,
        email_client,
        tel_client,
        nome_client,
        cognome_client,
        via_client,
        città_client,
        paese_client,
        zip_client,
    } = customerObj;

    window.dataLayer.push({
        event: PURCHASE,
        ecommerce: {
            transaction_id: transactionID,
            value,
            tax,
            shipping,
            currency: window.currency || '',
            coupon,
            payment_type: paymentType,
            shipping_type: shippingTier,
            new_client,
            email_client,
            tel_client,
            nome_client,
            cognome_client,
            via_client,
            città_client,
            paese_client,
            zip_client,
            items,
        },
    });
}

/**
 * Measures Login event.
 *
 */
export function onLogin(cid) {
    if (!cid || !enabled) {
        return;
    }
    window.dataLayer.push({
        event: LOGIN,
        user_id: cid,
    });
}

/**
 * Measures SIGNUP event.
 *
 */
export function onSignUp(method = 'email') {
    if (!enabled) {
        return;
    }
    window.dataLayer.push({
        event: SIGNUP,
        method,
    });
}

/**
 * search event.
 *
 */
export function onSearch(search_term) {
    if (!search_term || !enabled) return;

    window.dataLayer.push({
        event: SEARCH,
        search_term,
    });
}
